import * as React from 'react';
import './SimpleWinePageContainer.scss';
import { RouteComponentProps } from 'react-router-dom';
const background = require('./simplewine.jpg');

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

export class SimpleWinePageContainer extends React.Component<RouteProps> {

    componentDidMount() {
        document.title = 'Привилегии в SimplePrivé';
    }

    render() {
        return (
            <div className='simplewine_container'>
                <div className='content_container'>
                    <div className='image_container'>
                        <img
                            src={background}
                            alt='Изображение вина'
                        />
                    </div>
                    <h1>
                        Вам доступен сервис «Сомелье» и привилегии в SimplePrivé
                    </h1>
                    <p>
                        Ваши привилегии:
                    </p>
                    <ul>
                        <li>
                            индивидуальное обслуживание и консультации персонального сомелье
                        </li>
                        <li>
                            статус Gold — скидка 30% на основной ассортимент
                        </li>
                        <li>
                            скидка 15% при покупке в винотеках <a href='https://simplewine.ru/' target='_blank'>SimpleWine</a>
                        </li>
                        <li>
                            скидки до 40% в рамках закрытых акций
                        </li>
                        <li>
                            доступ к коллекционным и лимитированным позициям
                        </li>
                        <li>
                            удобное получение заказа
                        </li>
                        <li>
                            посещение камерных мероприятий, посвященных винной культуре.
                        </li>
                    </ul>
                    <p>
                        Персональный сомелье SimplePrivé – ваш личный эксперт, который поможет с выбором и предложит лучшее из ассортимента.
                    </p>
                    <p>
                        <b>
                            Открывайте новые вкусы вместе с нами.
                        </b>
                    </p>
                    <p>
                        <b>
                            Чтобы воспользоваться предложением и сервисом «Сомелье», пройдите регистрацию и получите статус Gold  на сайте SimplePrivé.
                        </b>
                    </p>
                </div>
                <button
                    onClick={() => window.location.href = 'https://simplewine.ru/prive/promo/open-270915/'}
                >
                    Воспользоваться сервисом
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SimpleWine/SimpleWinePageContainer.tsx